import * as types from 'store/modules/calendar/mutation-types'
import calendar from 'api/calendar'
import moment from 'moment'
import { mocker } from 'api/calendar/mocker'
import _ from 'lodash'
import { constLabels } from 'assets/js/constLabels.js'
import swal from 'sweetalert'
// import axios from 'axios'

const label = require('src/../config/label')
const defaultDate = {
  currentYear: new Date().getFullYear(),
  currentMonth: new Date().getMonth() + 1,
  currentDate: new Date().getDate(),
  currentDay: new Date().getDay()
}

export default {
  state: {
    btnFilter: {
      tab1: true,
      tab2: true,
      tab3: true,
      tab4: true
    },
    foundCalendar: {
      tab1: false,
      tab2: false,
      tab3: false,
      tab4: false
    },
    currentYear: defaultDate.currentYear,
    currentMonth: defaultDate.currentMonth,
    currentDate: defaultDate.currentDate,
    currentDay: defaultDate.currentDay,
    selectingYear: defaultDate.currentYear,
    selectingMonth: defaultDate.currentMonth,
    selectedYear: defaultDate.currentYear,
    selectedMonth: defaultDate.currentMonth,
    selectedDate: defaultDate.currentDate,
    selectedDay: defaultDate.currentDay,
    days: label.days,
    month: label.month,
    nextPage: false,
    filterImage: false,
    filterImageDisp: true,
    mainCalendar: true,
    calendarTab1Disp: false,
    calendarTab2Disp: false,
    calendarTab3Disp: false,
    calendarTab4Disp: false,
    calendarSwitch: true,
    calendarTab1: {
      total: 0,
      rows: [{
        date: 0,
        month: 0,
        year: 0,
        staappr: '',
        dtereq: '',
        status: '',
        descType: '',
        timstrt: '',
        timend: '',
        dtestrt: '',
        dteend: '',
        descDetail: '',
        remark: ''
      }]
    },
    calendarTab2: {
      total: 0,
      rows: [{
        date: 0,
        month: 0,
        year: 0,
        descTime: '',
        place: '',
        descDetail: ''
      }]
    },
    calendarTab3: {
      total: 0,
      rows: [{
        date: 0,
        month: 0,
        year: 0,
        title: '',
        timestr: '',
        timeend: '',
        place: ''
      }]
    },
    calendarTab4: {
      total: 0,
      rows: [{
        id: 0,
        date: 0,
        month: 0,
        year: 0,
        numseq: 0,
        topic: '',
        timstrt: '',
        timend: '',
        checked: '',
        place: ''
      }]
    },
    calendarMain: {},
    calendarHoliday: {
      total: 0,
      rows: [{
        date: 0,
        month: 0,
        year: 0,
        codempid: '',
        dtework: '',
        typwork: '',
        desholdy: ''
      }]
    },
    disableCalendarYearButton: false
  },
  getters: {
    [types.GET_BTN_FILTER] (state) {
      return state.btnFilter
    },
    [types.GET_FOUND_CALENDAR] (state) {
      return state.foundCalendar
    },
    [types.GET_CURRENT_YEAR] (state) {
      return state.currentYear
    },
    [types.GET_CURRENT_MONTH] (state) {
      return state.currentMonth
    },
    [types.GET_CURRENT_DATE] (state) {
      return state.currentDate
    },
    [types.GET_CURRENT_DAY] (state) {
      return state.currentDay
    },
    [types.GET_SELECTING_YEAR] (state) {
      return state.selectingYear
    },
    [types.GET_SELECTING_MONTH] (state) {
      return state.selectingMonth
    },
    [types.GET_SELECTED_YEAR] (state) {
      return state.selectedYear
    },
    [types.GET_SELECTED_MONTH] (state) {
      return state.selectedMonth
    },
    [types.GET_SELECTED_DATE] (state) {
      return state.selectedDate
    },
    [types.GET_SELECTED_DAY] (state) {
      return state.selectedDay
    },
    [types.GET_DAYS] (state) {
      return state.days
    },
    [types.GET_MONTH] (state) {
      return state.month
    },
    [types.GET_NEXT_PAGE] (state) {
      return state.nextPage
    },
    [types.GET_FILTER_IMAGE] (state) {
      return state.filterImage
    },
    [types.GET_FILTER_IMAGE_DISP] (state) {
      return state.filterImageDisp
    },
    [types.GET_MAIN_CALENDAR] (state) {
      return state.mainCalendar
    },
    [types.GET_CALENDAR_TAB1_DISP] (state) {
      return state.calendarTab1Disp
    },
    [types.GET_CALENDAR_TAB2_DISP] (state) {
      return state.calendarTab2Disp
    },
    [types.GET_CALENDAR_TAB3_DISP] (state) {
      return state.calendarTab3Disp
    },
    [types.GET_CALENDAR_TAB4_DISP] (state) {
      return state.calendarTab4Disp
    },
    [types.GET_CALENDAR_SWITCH] (state) {
      return state.calendarSwitch
    },
    [types.GET_DISABLE_CALENDAR_YEAR_BUTTON] (state) {
      return state.disableCalendarYearButton
    },
    [types.GET_CALENDAR_TAB1] (state) {
      return state.calendarTab1
    },
    [types.GET_CALENDAR_TAB2] (state) {
      return state.calendarTab2
    },
    [types.GET_CALENDAR_TAB3] (state) {
      return state.calendarTab3
    },
    [types.GET_CALENDAR_TAB4] (state) {
      return state.calendarTab4
    },
    [types.GET_CALENDAR_MAIN] (state) {
      return state.calendarMain
    },
    [types.GET_CALENDAR_HOLIDAY] (state) {
      return state.calendarHoliday
    }
  },
  mutations: {
    [types.SET_BTN_FILTER] (state, btnFilter) {
      state.btnFilter = btnFilter
    },
    [types.SET_FOUND_CALENDAR] (state, foundCalendar) {
      state.foundCalendar = foundCalendar
    },
    [types.SET_SELECTING_YEAR] (state, year) {
      state.selectingYear = state.selectingYear + year
    },
    [types.SET_SELECTING_MONTH] (state, month) {
      state.selectingMonth = month
      if (!state.calendarSwitch) { // monthMode
        state.selectedYear = state.selectingYear
        state.selectedMonth = month
      }
    },
    [types.SET_ADD_DATE] (state, dayAmount) {
      let stateDate = new Date(state.selectedYear, state.selectedMonth - 1, state.selectedDate)
      stateDate.setDate(stateDate.getDate() + dayAmount)
      const selectDate = stateDate.getDate()
      const selectMonth = stateDate.getMonth() + 1
      const selectYear = stateDate.getFullYear()
      const selectDay = state.selectedDay + dayAmount
      const indexDay = (selectDay > 6) ? 0 : ((selectDay < 0) ? 6 : selectDay)
      state.selectingMonth = selectMonth
      state.selectingYear = selectYear
      state.selectedDate = selectDate
      state.selectedMonth = selectMonth
      state.selectedYear = selectYear
      state.selectedDay = indexDay
    },
    [types.SET_ADD_MONTH] (state, monthAmount) {
      let stateDate = new Date(state.selectedYear, state.selectedMonth - 1, state.selectedDate)
      stateDate.setMonth(stateDate.getMonth() + monthAmount)
      const selectDate = 1
      const selectMonth = stateDate.getMonth() + 1
      const selectYear = stateDate.getFullYear()
      const indexDay = Number(moment(moment().format(selectYear + '-' + _.padStart(selectMonth, 2, '0') + '-01')).format('e'))
      state.selectingMonth = selectMonth
      state.selectingYear = selectYear
      state.selectedDate = selectDate
      state.selectedMonth = selectMonth
      state.selectedYear = selectYear
      state.selectedDay = indexDay
    },
    [types.SET_SELECTING_DATE] (state, objDate) {
      state.selectedYear = state.selectingYear
      state.selectedMonth = state.selectingMonth
      state.selectedDate = objDate.date
      state.selectedDay = objDate.day
    },
    [types.SET_CALENDAR_DISP] (state, page) {
      state.nextPage = false
      state.filterImageDisp = false
      state.mainCalendar = false
      state.calendarTab1Disp = false
      state.calendarTab2Disp = false
      state.calendarTab3Disp = false
      state.calendarTab4Disp = false
      switch (page) {
        case 'index':
          state.filterImageDisp = true
          state.mainCalendar = true
          break
        case 'calendarTab1Disp':
          state.calendarTab1Disp = true
          state.nextPage = true
          break
        case 'calendarTab2Disp':
          state.calendarTab2Disp = true
          state.nextPage = true
          break
        case 'calendarTab3Disp':
          state.calendarTab3Disp = true
          state.nextPage = true
          break
        case 'calendarTab4Disp':
          state.calendarTab4Disp = true
          state.nextPage = true
          break
        default:
          state.mainCalendar = true
          break
      }
    },
    [types.SET_FILTER_IMAGE] (state, filterImage) {
      state.filterImage = filterImage
    },
    [types.SET_FILTER_IMAGE_DISP] (state, filterImageDisp) {
      state.filterImageDisp = filterImageDisp
    },
    [types.SET_CALENDAR_SWITCH] (state, calendarSwitch) {
      state.calendarSwitch = calendarSwitch
    },
    [types.SET_DISABLE_CALENDAR_YEAR_BUTTON] (state, disableCalendarYearButton) {
      state.disableCalendarYearButton = disableCalendarYearButton
    },
    [types.SET_CALENDAR_TAB1_DISP] (state, calendarTab1Disp) {
      state.calendarTab1Disp = calendarTab1Disp
    },
    [types.SET_CALENDAR_TAB1] (state, calendarTab1) {
      state.calendarTab1 = calendarTab1
    },
    [types.SET_CALENDAR_TAB2] (state, calendarTab2) {
      state.calendarTab2 = calendarTab2
    },
    [types.SET_CALENDAR_TAB3] (state, calendarTab3) {
      state.calendarTab3 = calendarTab3
    },
    [types.SET_CALENDAR_TAB4] (state, calendarTab4) {
      state.calendarTab4 = calendarTab4
    },
    [types.SET_CALENDAR_HOLIDAY] (state, calendarHoliday) {
      state.calendarHoliday = calendarHoliday
    },
    [types.SAVE_CALENDAR_TAB4] (state, sendParams) {
      if (sendParams.flgsave === 'add') {
        state.calendarTab4.rows.push({
          id: sendParams.id,
          date: sendParams.date,
          month: sendParams.month,
          year: sendParams.year,
          numseq: sendParams.numseq,
          topic: sendParams.topic,
          timstrt: sendParams.timstrt,
          timend: sendParams.timend,
          checked: 'N',
          place: sendParams.place
        })
        state.calendarTab4.total += 1
        state.calendarMain.month[state.selectedMonth - 1][state.selectedDate - 1]['tab4'] = true
      } else if (sendParams.flgsave === 'edit') {
        let rowIndex = state.calendarTab4.rows.map(function (calendarTab4Row) {
          return calendarTab4Row.id
        }).indexOf(sendParams.id)
        state.calendarTab4.rows[rowIndex] = {
          id: sendParams.id,
          date: sendParams.date,
          month: sendParams.month,
          year: sendParams.year,
          numseq: sendParams.numseq,
          topic: sendParams.topic,
          timstrt: sendParams.timstrt,
          timend: sendParams.timend,
          checked: sendParams.checked,
          place: sendParams.place
        }
      } else if (sendParams.flgsave === 'delete') {
        let rowIndex = state.calendarTab4.rows.map(function (calendarTab4Row) {
          return calendarTab4Row.id
        }).indexOf(sendParams.id)
        state.calendarTab4.rows.splice(rowIndex, 1)
        let foundCalendarTab4Rows = _.filter(state.calendarTab4.rows, function (calendarTab4Row) {
          return calendarTab4Row.date === state.selectedDate &&
                 calendarTab4Row.month === state.selectedMonth &&
                 calendarTab4Row.year === state.selectedYear
        })
        if (foundCalendarTab4Rows.length > 0) {
          state.calendarMain.month[state.selectedMonth - 1][state.selectedDate - 1]['tab4'] = true
        } else {
          state.calendarMain.month[state.selectedMonth - 1][state.selectedDate - 1]['tab4'] = false
        }
      }
    },
    [types.SET_CALENDAR_MAIN] (state, year) {
      state.calendarMain = mocker.calendarMain(year)
    },
    [types.SET_CALENDAR_MAIN_BOOLEAN] (state, obj) {
      _.each(obj.calendarTabRows, function (calendarTabRow) {
        state.calendarMain.month[calendarTabRow.month - 1][calendarTabRow.date - 1][obj.tab] = true
      })
    }
  },
  actions: {
    [types.RECEIVED_ALL_CALENDARTAB] ({ state, commit, dispatch }, {year, getDescHoliday}) {
      commit(types.SET_CALENDAR_MAIN, year)
      commit(types.SET_DISABLE_CALENDAR_YEAR_BUTTON, true)
      /* axios.all([
        calendar.receivedcalendarTab1(year),
        calendar.receivedcalendarTab2(year),
        calendar.receivedcalendarTab3(year),
        calendar.receivedcalendarTab4(year),
        calendar.receivedHoliday(year)
      ])
      .then(axios.spread(function (responseTab1, responseTab2, responseTab3, responseTab4, responseHoliday) {
        commit(types.SET_CALENDAR_MAIN, year)
        const calendarTab1Obj = JSON.parse(responseTab1.request.response)
        commit(types.SET_CALENDAR_TAB1, calendarTab1Obj)
        commit(types.SET_CALENDAR_MAIN_BOOLEAN, { tab: 'tab1', calendarTabRows: calendarTab1Obj.rows })
        const calendarTab2Obj = JSON.parse(responseTab2.request.response)
        commit(types.SET_CALENDAR_TAB2, calendarTab2Obj)
        commit(types.SET_CALENDAR_MAIN_BOOLEAN, { tab: 'tab2', calendarTabRows: calendarTab2Obj.rows })
        const calendarTab3Obj = JSON.parse(responseTab3.request.response)
        commit(types.SET_CALENDAR_TAB3, calendarTab3Obj)
        commit(types.SET_CALENDAR_MAIN_BOOLEAN, { tab: 'tab3', calendarTabRows: calendarTab3Obj.rows })
        const calendarTab4Obj = JSON.parse(responseTab4.request.response)
        commit(types.SET_CALENDAR_TAB4, calendarTab4Obj)
        commit(types.SET_CALENDAR_MAIN_BOOLEAN, { tab: 'tab4', calendarTabRows: calendarTab4Obj.rows })
        const calendarHoliday = JSON.parse(responseHoliday.request.response)
        commit(types.SET_CALENDAR_HOLIDAY, calendarHoliday)
        commit(types.SET_DISABLE_CALENDAR_YEAR_BUTTON, false)
        getDescHoliday()
      }))
      .catch((error) => {
        let message = error
        if (error.response) {
          const data = error.response.data
          message = data.response
        }
        console.warn('warning !!! Please Refresh Page', message)
        if (message !== '' && message !== undefined) {
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        }
      }) */
      calendar.receivedcalendar(year)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_CALENDAR_MAIN, year)
          const calendarTab1Obj = data.calendarTab1
          commit(types.SET_CALENDAR_TAB1, calendarTab1Obj)
          commit(types.SET_CALENDAR_MAIN_BOOLEAN, { tab: 'tab1', calendarTabRows: calendarTab1Obj.rows })
          const calendarTab2Obj = data.calendarTab2
          commit(types.SET_CALENDAR_TAB2, calendarTab2Obj)
          commit(types.SET_CALENDAR_MAIN_BOOLEAN, { tab: 'tab2', calendarTabRows: calendarTab2Obj.rows })
          const calendarTab3Obj = data.calendarTab3
          commit(types.SET_CALENDAR_TAB3, calendarTab3Obj)
          commit(types.SET_CALENDAR_MAIN_BOOLEAN, { tab: 'tab3', calendarTabRows: calendarTab3Obj.rows })
          const calendarTab4Obj = data.calendarTab4
          commit(types.SET_CALENDAR_TAB4, calendarTab4Obj)
          commit(types.SET_CALENDAR_MAIN_BOOLEAN, { tab: 'tab4', calendarTabRows: calendarTab4Obj.rows })
          const calendarHoliday = data.calendarHoliday
          commit(types.SET_CALENDAR_HOLIDAY, calendarHoliday)
          commit(types.SET_DISABLE_CALENDAR_YEAR_BUTTON, false)
          getDescHoliday()
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('Try recieve calendar again', message)
          calendar.receivedcalendar(year)
            .then((response) => {
              const data2 = JSON.parse(response.request.response)
              commit(types.SET_CALENDAR_MAIN, year)
              const calendarTab1Obj = data2.calendarTab1
              commit(types.SET_CALENDAR_TAB1, calendarTab1Obj)
              commit(types.SET_CALENDAR_MAIN_BOOLEAN, { tab: 'tab1', calendarTabRows: calendarTab1Obj.rows })
              const calendarTab2Obj = data2.calendarTab2
              commit(types.SET_CALENDAR_TAB2, calendarTab2Obj)
              commit(types.SET_CALENDAR_MAIN_BOOLEAN, { tab: 'tab2', calendarTabRows: calendarTab2Obj.rows })
              const calendarTab3Obj = data2.calendarTab3
              commit(types.SET_CALENDAR_TAB3, calendarTab3Obj)
              commit(types.SET_CALENDAR_MAIN_BOOLEAN, { tab: 'tab3', calendarTabRows: calendarTab3Obj.rows })
              const calendarTab4Obj = data2.calendarTab4
              commit(types.SET_CALENDAR_TAB4, calendarTab4Obj)
              commit(types.SET_CALENDAR_MAIN_BOOLEAN, { tab: 'tab4', calendarTabRows: calendarTab4Obj.rows })
              const calendarHoliday = data2.calendarHoliday
              commit(types.SET_CALENDAR_HOLIDAY, calendarHoliday)
              commit(types.SET_DISABLE_CALENDAR_YEAR_BUTTON, false)
              getDescHoliday()
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data2 = error.response.data
                message = data2.response
              }
              console.warn('warning !!! Please Refresh Page', message)
              if (message !== '' && message !== undefined) {
                swal({
                  title: '', text: message, html: true, type: 'error'
                }, function () {
                  window.onkeydown = null; window.onfocus = null; swal('')
                })
              }
            })
        })
    },
    [types.POST_CALENDAR_TAB4_CHECKED] ({ commit }, sendParams) {
      calendar.postCalendarTab4Checked(sendParams)
        .then((response) => {
          // const data = JSON.parse(response.request.response)
          // swal({
          //   title: '', text: data.response, html: true, type: 'success'
          // }, function () {
          //   window.onkeydown = null; window.onfocus = null; swal('')
          // })
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          console.warn('warning !!! Please Refresh Page', message)
          if (message !== '' && message !== undefined) {
            swal({
              title: '', text: message, html: true, type: 'error'
            }, function () {
              window.onkeydown = null; window.onfocus = null; swal('')
            })
          }
        })
    },
    [types.POST_CALENDAR_TAB4] ({ commit }, params) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmSave'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          let sendParams = params.sendParams
          let calendarTab4Row = params.calendarTab4Row
          calendar.postCalendarTab4(calendarTab4Row)
            .then((response) => {
              const data = JSON.parse(response.request.response)
              sendParams.numseq = parseInt(data.numseq)
              commit(types.SAVE_CALENDAR_TAB4, sendParams)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              console.warn('warning !!! Please Refresh Page', message)
              if (message !== '' && message !== undefined) {
                swal({
                  title: '', text: message, html: true, type: 'error'
                }, function () {
                  window.onkeydown = null; window.onfocus = null; swal('')
                })
              }
            })
        }
      })
    },
    [types.DELETE_CALENDAR_TAB4] ({ commit }, sendParams) {
      swal({
        title: constLabels('confirmTitle'),
        text: constLabels('msgConfirmDelete'),
        showCancelButton: true,
        closeOnConfirm: false,
        confirmButtonText: constLabels('ok'),
        cancelButtonText: constLabels('cancel')
      },
      function (isConfirm) {
        if (isConfirm) {
          calendar.deleteCalendarTab4(sendParams)
            .then((response) => {
              commit(types.SAVE_CALENDAR_TAB4, sendParams)
              const data = JSON.parse(response.request.response)
              swal({
                title: '', text: data.response, html: true, type: 'success'
              }, function () {
                window.onkeydown = null; window.onfocus = null; swal('')
              })
            })
            .catch((error) => {
              let message = error
              if (error.response) {
                const data = error.response.data
                message = data.response
              }
              console.warn('warning !!! Please Refresh Page', message)
              if (message !== '' && message !== undefined) {
                swal({
                  title: '', text: message, html: true, type: 'error'
                }, function () {
                  window.onkeydown = null; window.onfocus = null; swal('')
                })
              }
            })
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/calendar/index.js